import {combineReducers} from 'redux';
import {handleActions} from 'redux-actions';
import {List, Map} from 'immutable';

import * as actionTypes from 'web-app/react/constants/action-types';
import PlatformHelper from 'web-app/helpers/platform-helper';

import profileImageReducer from './profile-image/reducer';
import FileRecord from './file-record';
import * as Helpers from './typed-helpers';

const addFile = (state, formName, file) => {
    let files = state.get(formName) || List();
    const newFile =
        files.size === 0 ||
        !files.find(item => {
            return item.id === file.id;
        });
    if (newFile) {
        files = files.push(new FileRecord({...file, item: {mediaType: Helpers.getFileMediaType(file)}}));
    }
    return state.set(formName, files);
};

const fileUploadReducer = handleActions(
    {
        [actionTypes.FILE_UPLOAD_LOAD_FILES]: (state, {payload}) => {
            const {formName, files} = payload;
            return state.set(formName, files);
        },
        [actionTypes.FILE_UPLOAD_ADD_FILE]: (state, action) => {
            const file = action.payload.file;
            return addFile(state, action.payload.formName, {name: file.name, id: file.id, type: file.type, file});
        },
        [actionTypes.FILE_UPLOAD_REMOVE_FILE]: (state, action) => {
            let files = state.get(action.payload.formName);
            files = files.filter(file => {
                return file.id !== action.payload.file.id;
            });
            return state.set(action.payload.formName, files);
        },
        [actionTypes.FILE_UPLOAD_READ_FILE_SUCCESS]: (state, action) => {
            let files = state.get(action.payload.formName);
            const fileIndex = files.findIndex(file => {
                return file.id === action.payload.file.id;
            });
            if (fileIndex === -1) {
                return state;
            }
            files = files.update(fileIndex, file => {
                const data = action.payload.data;
                if (data.duration) {
                    return file.merge({previewUrl: data.image, videoDuration: data.duration});
                }
                return file.merge({previewUrl: data.image});
            });
            return state.set(action.payload.formName, files);
        },
        [actionTypes.FILE_UPLOAD_FILE_UPLOAD_PROGRESS]: (state, action) => {
            let files = state.get(action.payload.formName);
            const [fileIndex, file] = files.findEntry(file => {
                return file.id === action.payload.file.id;
            }) || [-1];
            if (fileIndex === -1) {
                return state;
            }
            // Ignore if progress manually set to higher value
            if (action.payload.percentLoaded < file.uploadProgress) {
                return state;
            }
            // Only increment if loaded more than additional 10 percent for mobile devices
            if (PlatformHelper.isMobileApp() && action.payload.percentLoaded <= file.uploadProgress + 10) {
                return state;
            }
            files = files.update(fileIndex, file => {
                return file.merge({uploadProgress: action.payload.percentLoaded});
            });
            return state.set(action.payload.formName, files);
        },
        [actionTypes.FILE_UPLOAD_FILE_UPLOAD_FAILED]: (state, action) => {
            let files = state.get(action.payload.formName);
            const fileIndex = files.findIndex(file => {
                return file.id === action.payload.file.id;
            });
            if (fileIndex === -1) {
                return state;
            }
            files = files.update(fileIndex, file => {
                return file.merge({uploadProgress: -1});
            });
            return state.set(action.payload.formName, files);
        },
        [actionTypes.FILE_UPLOAD_FILE_PERSIST_SUCCESS]: (state, action) => {
            let files = state.get(action.payload.formName);
            const fileIndex = files.findIndex(file => {
                return file.id === action.payload.file.id;
            });
            if (fileIndex === -1) {
                return state;
            }
            files = files.update(fileIndex, file => {
                const persistedFile = action.payload.persistedFile;
                return file.merge({
                    item: persistedFile,
                    uploadProgress: null,
                    id: persistedFile.imageId || persistedFile.videoId || persistedFile.fileId,
                    thumbnailUrl: persistedFile.objectUrlSmall,
                    url: persistedFile.url || persistedFile.objectUrl,
                });
            });
            return state.set(action.payload.formName, files);
        },
        [actionTypes.FILE_UPLOAD_FILE_PERSIST_FAILED]: (state, action) => {
            let files = state.get(action.payload.formName);
            const fileIndex = files.findIndex(file => {
                return file.id === action.payload.file.id;
            });
            if (fileIndex === -1) {
                return state;
            }
            files = files.update(fileIndex, file => {
                return file.merge({uploadProgress: -1});
            });
            return state.set(action.payload.formName, files);
        },
        [actionTypes.FILE_UPLOAD_CLEAR_FILES]: (state, action) => {
            return state.set(action.payload.formName, List());
        },
        [actionTypes.FILE_UPLOAD_ADD_UPLOADED_FILE]: (state, action) => {
            const file = action.payload.file;
            file.uploadProgress = null;
            return addFile(state, action.payload.formName, file);
        },
    },
    Map(),
);

const fileUpload = combineReducers({
    files: fileUploadReducer,
    profileImages: profileImageReducer,
});

export default fileUpload;
